module.exports = __webpack_public_path__ + "img/map.f4883f6a.webp";